import 'whatwg-fetch';
import 'idempotent-babel-polyfill';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import queryString from 'query-string';

var listLoads = [];
var autoCompletePath = '';

/**
 * REFRACTOR pass service path from triggering component
 * @param {*} data 
 * @returns 
 */
async function attributeSearchAutoCompleteApi(data) {
  autoCompletePath = ProductFinder.options.settings.attributeSearchAutoCompletePath;
  let query = {};
  let queryPath = autoCompletePath;
  query['search'] = data.search;
  // Get the current filters.
  for (let [key, value] of Object.entries(data.filters)) {
    if (value) {
      query['filter[' + key + ']'] = value;
    }
  }
  // Get the current attribute filters.
  for (let [key, value] of Object.entries(data.attributeFilters)) {
    if (value) {
      query['filter[attributes][' + key + ']'] = value;
    }
  }

  queryPath = queryPath + '?' + queryString.stringify(query, { arrayFormat: 'bracket' });
  // Get the current sort.
  listLoads.forEach((control) => {
    control.abort();
  })
  listLoads = [];
  const controller = new AbortController();
  listLoads.push(controller);
  const signal = controller.signal;
  try {
    const response = await window.fetch(queryPath, { signal: signal });
    return await response.json();
  } catch (e) {
    return null;
  }
}

export default attributeSearchAutoCompleteApi;
